import { render, staticRenderFns } from "./material.vue?vue&type=template&id=7fe95837&scoped=true&"
import script from "./material.vue?vue&type=script&lang=js&"
export * from "./material.vue?vue&type=script&lang=js&"
import style0 from "./material.vue?vue&type=style&index=0&lang=css&"
import style1 from "./material.vue?vue&type=style&index=1&id=7fe95837&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe95837",
  null
  
)

export default component.exports